import { createSlice } from "@reduxjs/toolkit"
import type { RootState } from "../../app/store"

interface CounterState {
  value: number
  isUnderOneMin: boolean
  isUnderTwoMin: boolean
}

const initialState: CounterState = {
  value: null,
  isUnderOneMin: false,
  isUnderTwoMin: false,
}

export const DEFAULT_TIMER_IN_SECS = 300
export const DEFAULT_EXPIRY_IN_SECS = 180

export const counterSlice = createSlice({
  name: "counter",
  initialState,
  reducers: {
    setCounter: (state) => {
      const expiresInSeconds = Number.parseInt(
        sessionStorage.getItem("expires_in"),
        10,
      )
      const start = new Date(sessionStorage.getItem("created_at"))
      const end = new Date(start.getTime() + expiresInSeconds * 1000)
      const secondBetweenTwoDates = Math.round(
        (end.getTime() - Date.now()) / 1000,
      )

      state.value = secondBetweenTwoDates
      state.isUnderOneMin = secondBetweenTwoDates < 60
      state.isUnderTwoMin = secondBetweenTwoDates < 120
    },
  },
})

export const { setCounter } = counterSlice.actions
export const selectCounter = (state: RootState) => state.counter.value
export default counterSlice.reducer
